import React, { useMemo, useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Input from '../../shared/components/formElements/Input';
import Button from '../../shared/components/formElements/Button';
import { AuthContext } from '../../shared/context/auth-context';
import { useCustomers } from '../../shared/hooks/customers-hook';
import {
  VALIDATOR_SPECIAL_CHARACHTER,
  VALIDATOR_MAXLENGTH,
  VALIDATOR_NUMERIC
} from '../../shared/util/validators';
import { useForm } from '../../shared/hooks/form-hook';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { v4 as uuid } from 'uuid';
import OrderList from '../components/OrderList'
import CustomerOrderList from '../components/CustomerOrderList'
import Toggle from '../../shared/components/formElements/Toggle'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "tachyons";

import './Orders.css';
import './NewOrder.css';
import Capitalize from '../../shared/components/UIElements/Capitalize ';

export const momentDate = () => {
  let date = new Date()
  let day = date.getDate();
  let month = date.getMonth()+1;
  let year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

const NewOrder = () => {
  const { customers } = useCustomers()
  const auth = useContext(AuthContext);
  const orderNumber = useMemo(() => uuid().slice(0,8),[]);

  const [loadedItems, setLoadedItems] = useState([]);

  const [startDate, setStartDate] = useState(new Date(momentDate()));
  const [eventDate, setEventDate] = useState(new Date(momentDate()));

  const history = useHistory();

  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler] = useForm(
      {
      customer: {
          value: "",
          isValid: false
      },
      startDate: {
          value: startDate,
          isValid: true
      },
      eventDate: {
        value: eventDate,
        isValid: true
      },
      items: {
          value: [],
          isValid: false
      },
      orderNumber: {
          value: orderNumber,
          isValid: true
      },
      description: {
        value: "",
        isValid: true
      },
      archive: {
        value: false,
        isValid: true,
      },
      deposit : {
        value: 0,
        isValid: true,
      },
      tax : {
        value: false,
        isValid: true,
      }
      },
      false
  );

  useEffect(() => {
    formState.inputs.startDate.value = startDate;
    formState.inputs.eventDate.value = eventDate;
  }, [startDate, eventDate, formState.inputs.startDate, formState.inputs.eventDate]);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const responseItemsData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+"/items",
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedItems(responseItemsData.items);
      } catch (err) {}
    };
    fetchItems();
  }, [sendRequest, auth.token]);

  const fixedStyleItems = loadedItems.map(item => {
    return({
      ...item,
      style : item.style.replaceAll('_',"/")
    })
  })

    const orderSubmitHandler = async event => {

      event.preventDefault();
      let customerResponse;
      //if customer temporary id is equal to new, first create a customer.
      if (formState.inputs.customer.value[0].id === "new") {
        try {
          customerResponse = await sendRequest(
            process.env.REACT_APP_BACKEND_URL+'/customers/new',
            'POST',
            JSON.stringify({
              name: Capitalize(formState.inputs.customer.value[0].name),
              lastname: Capitalize(formState.inputs.customer.value[0].lastname),
              phone: formState.inputs.customer.value[0].phone,
              address: " ",
            }),
            { 'Content-Type': 'application/json',
            Authorization: 'Bearer '+ auth.token }
          );
        } catch (err) {}
      }

      if(!customerResponse && formState.inputs.customer.value[0].id === "new"){
        return 
      }

      const itemsList = formState.inputs.items.value.map(item => [item.id, item.quantity])
 
      itemsList.forEach(async item => {
        try {
          await sendRequest(
            process.env.REACT_APP_BACKEND_URL+'/orders/decrement',
            "PATCH",
            JSON.stringify({
              quantity: item[1],
              id: item[0]
            }),
            {
              "Content-Type": "application/json",
              Authorization: 'Bearer '+ auth.token
            }
          );
        } catch (err) {}
      })

    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+'/orders/new',
        'POST',
        JSON.stringify({
            customer: formState.inputs.customer.value,
            startDate: formState.inputs.startDate.value,
            eventDate: formState.inputs.eventDate.value,
            orderNumber: formState.inputs.orderNumber.value,
            description: Capitalize(formState.inputs.description.value),
            deposit: formState.inputs.deposit.value,
            items: formState.inputs.items.value,
            archive: formState.inputs.archive.value,
            tax: formState.inputs.tax.value
        }),
        { 'Content-Type': 'application/json',
        Authorization: 'Bearer '+ auth.token }
      );
    } catch (err) {}

    const hasSpecial = formState.inputs.items.value.some((any) => any.type === "special");
    if (hasSpecial) {
      try {
        await sendRequest(
          process.env.REACT_APP_BACKEND_URL+'/items/special/delete',
          'DELETE',
          JSON.stringify({
              items: formState.inputs.items.value
          }),
          { 'Content-Type': 'application/json',
          Authorization: 'Bearer '+ auth.token }
        );
        
      } catch (err) {}
    } 
    history.push('/orders');
  };

  formState.inputs.items.value.some((any) => any.type === "special")
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <form className="order-form" onSubmit={orderSubmitHandler}>
        {isLoading && <LoadingSpinner asOverlay />}
        <h2 style={{textAlign: 'center'}}>Create New Sales Receipt</h2>
        <div className="flex justify-between">
          <div className=" w-third mr2 pa2">
            <code>
            <label >Receipt Number</label>
            <input readOnly className="input-reset ba b--black-20 pa2 mb2 db w-100 h" type="text" value={orderNumber}/>
            </code>
          </div>
          <div className=" w-third mr2 pa2">
            <code>
              <label >Order Date</label>
              <DatePicker className='order-date' selected={startDate} onChange={(date) => setStartDate(date)} />
            </code>
          </div>
          <div className=" w-third mr2 pa2">
            <code>
            
            <label >Event Date</label>
            <DatePicker className='order-date' selected={eventDate} onChange={(eventDate) => setEventDate(eventDate)} />
            </code>
          </div>
        </div>
        
        <CustomerOrderList 
          id="customer"
          label="Customer"
          onInput={inputHandler}
          type="text"
          suggestionArray={customers}
        />
        <OrderList 
          id="items"
          label="Item"
          onInput={inputHandler}
          type="text"
          suggestionArray={fixedStyleItems}    
          deposit={formState.inputs.deposit.value} 
          tax={formState.inputs.tax.value}  
        />
        <div style={{maxWidth:"750px"}}>
        <div className='flex justify-between'>
          <div className="w-50">
          <Input
            id="description"
            label="Description"
            validators={[VALIDATOR_SPECIAL_CHARACHTER(), VALIDATOR_MAXLENGTH(180)]}
            onInput={inputHandler}
            errorText="Please enter a valid description (Max 180 Characters)."
        />

          </div>
        <div className=" w-25 ml4">
         <Input
              id="deposit"
              element="input"
              type="number"
              label="Deposit"
              placeholder={"$ 0.00"}
              validators={[VALIDATOR_MAXLENGTH(10), VALIDATOR_NUMERIC()]}
              errorText="Please enter a valid price."
              onInput={inputHandler}
          />
        </div>
        <div className=" w-25" style={{marginTop:"41px"}}>
           
            <Toggle 
            label="Tax"
            onInput={inputHandler}
            id="tax"
          />
        </div>

          </div>
   
        </div>
        {/* <div style={{width:"70%"}}>

        <Input
            id="description"
            label="Description"
            validators={[VALIDATOR_SPECIAL_CHARACHTER(), VALIDATOR_MAXLENGTH(180)]}
            onInput={inputHandler}
            errorText="Please enter a valid description (Max 180 Characters)."
        />
        </div> */}
        <Button type="submit" disabled={!formState.isValid} >
            ADD Receipt
        </Button>
        <Button inverse to="/orders">
            CANCEL
        </Button>
      </form>
    </React.Fragment>
  );
};

export default NewOrder;
